import { useEffect, useState } from 'react';
import { useBookingContext } from '../../../contexts/BookingProvider';
import useAppointmentActions from '../../../hooks/APIHooks/appointments/useAppointmentActions';
import {
  AppointmentSlot,
  AvailableAssociate,
} from '../../../types/appointments';
import {
  extractPartialTimeSlots,
  hasAvailableSlotsInTimeGrid,
} from '../../../utils/timeAndDate';
import BookingAvailableDiv from './BookingAvailableDiv';
import BookingNotAvailableDiv from './BookingNotAvailableDiv';

const BookingAvailabilityRow = ({
  date,
  associate,
}: {
  date: string;
  associate: AvailableAssociate;
}) => {
  // integration of react hooks here
  const [availableSlots, setAvailableSlots] = useState<Array<AppointmentSlot>>(
    []
  );
  const [availabilitySlot, setAvailabilitySlot] = useState<
    Array<{ start_time: number; end_time: number; has_slot: boolean }>
  >([]);

  // integration of context hooks here
  const { serviceId } = useBookingContext();

  // integration of custom API hooks here
  const { getAvailableSlotsHandler } = useAppointmentActions('');

  // fetching available slots for specific associate here
  useEffect(() => {
    getAvailableSlotsHandler
      .mutateAsync({
        body: {
          associate_id: associate.id,
          service_id: serviceId,
          date,
          current_time: new Date().toLocaleTimeString('en-GB', {
            hour12: false,
          }),
        },
      })
      .then((res) => {
        if (res.is_success) {
          setAvailableSlots(res.data);
        } else {
          setAvailableSlots([]);
        }
      })
      .catch((error) => setAvailableSlots([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [associate, serviceId, date]);

  // checking if associate have appointment slots in specific time window here
  useEffect(() => {
    if (availableSlots.length) {
      setAvailabilitySlot(
        hasAvailableSlotsInTimeGrid(
          availableSlots.map((slot) => +slot.start_time.split(':')[0])
        )
      );
    } else {
      setAvailabilitySlot(hasAvailableSlotsInTimeGrid());
    }
  }, [availableSlots]);

  console.log(availableSlots, availabilitySlot, date, associate.id);

  // rendering booking availability row component here
  return (
    <div className='grid grid-cols-6 [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-legal-dark-blue'>
      {availabilitySlot.map((slot, index) =>
        slot.has_slot ? (
          <BookingAvailableDiv
            date={date}
            associate={associate}
            partialTimeSlots={extractPartialTimeSlots(
              availableSlots,
              slot.start_time,
              slot.end_time
            )}
            key={index}
          />
        ) : (
          <BookingNotAvailableDiv key={index} />
        )
      )}
    </div>
  );
};

export default BookingAvailabilityRow;
